import React from 'react';
import PropTypes from 'prop-types';
import { ButtonKeetUI } from '@keethealth/ui-components';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { logoutUser } from 'redux/auth/actions';
import { connect } from 'react-redux';
import './invalid_qr_code.scss';

const mapDispatchToProps = dispatch => ({
  onLogout: () => { dispatch(logoutUser()); },
});

function InvalidQRCode({ onLogout, history }) {
  return (
    <div className="errorPage">
      <div className="content-container">
        <h1 className="f-subheadline b mb4">Invalid QR Code</h1>
        <h2>This QR code is no longer valid or has expired. Please contact your healthcare provider for a new QR code.</h2>
        {renderButtons()}
      </div>
    </div>
  );

  function handleLogout() {
    onLogout();
  }

  function handleHome() {
    history.push('/my_tasks');
  }

  function renderButtons() {
    return (
      <div className="flex justify-center flex-row-ns flex-column mt4" data-testid="invalid-qr-code">
        <ButtonKeetUI
          className="mr3-ns mb3"
          onClick={handleHome}
        >
          Back to Home
        </ButtonKeetUI>
        <ButtonKeetUI
          onClick={handleLogout}
          className="mb3"
        >
          Log Out
        </ButtonKeetUI>
      </div>
    );
  }
}

InvalidQRCode.propTypes = {
  onLogout: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default compose(
  connect(null, mapDispatchToProps),
  withRouter,
)(InvalidQRCode);
